export default {
  namespaced: true,
  state: {
    limits: [],
  },
  actions: {
    // eslint-disable-next-line camelcase
    GetLimits({ commit, rootGetters, dispatch }, profile_id) {
      commit('setField', { name: 'limits', value: [] });
      return new Promise((resolve, reject) => {
        rootGetters.axl.post('sales/api/v3/sales/limits', { profile_id })
          .then((response) => {
            if (response && response.data) {
              commit('setField', { name: 'limits', value: response.data.limits });
              resolve(response.data);
            }
            reject(new Error('no response data'));
          })
          .catch((error) => {
            dispatch('HandleError', error, { root: true });
            reject(error);
          });
      });
    },
    InitialStoreLimits({ commit }) {
      commit('setField', { name: 'limits', value: [] });
    },
  },
  mutations: {
    setField(state, payload) {
      state[payload.name] = payload.value;
    },
  },
};
